import { useTranslation } from 'react-i18next';

const PendingInviteBadge = () => {
  const { t } = useTranslation();

  return (
    <span className="bg-gray-20 text-gray-80 px-2 py-px rounded-full text-xs leading-normal truncate max-w-fit">
      {t('workspaces.pending_invite')}
    </span>
  );
};

export default PendingInviteBadge;
